import Text from 'antd/lib/typography/Text';
import React, { ReactElement } from 'react';

import { IFlowInfoValueProps } from './FlowInfo.types';
import FlowInfoItem from './FlowInfoItem';

const FlowInfoValue = ({ title, value }: IFlowInfoValueProps): ReactElement => (
  <FlowInfoItem title={title}>
    <Text>{value}</Text>
  </FlowInfoItem>
);

export default FlowInfoValue;
